export default {"src":"/_next/static/media/uniswap.25e4c1ac.svg","height":194,"width":168,"blurWidth":0,"blurHeight":0};